package com.routexk.quiz.ui.utils

import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.cssRem

/**
 * Responsive pixel: design-spec px value expressed in rem so the whole funnel
 * scales with the root font-size (see the `html` clamp() rule in AppTheme).
 * 1rpx == 1px at the design reference size (16px root); smaller viewports
 * shrink everything proportionally (~0.8x on phones) and large desktops grow
 * it (up to 1.25x), keeping the design's proportions intact.
 */
val Int.rpx: CSSSizeValue<CSSUnit.rem> get() = (this / 16.0).cssRem

val Double.rpx: CSSSizeValue<CSSUnit.rem> get() = (this / 16.0).cssRem
